import { render, staticRenderFns } from "./url-rewriter.vue?vue&type=template&id=6a267c08&scoped=true&"
import script from "./url-rewriter.vue?vue&type=script&lang=js&"
export * from "./url-rewriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a267c08",
  null
  
)

export default component.exports